import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { MessageService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client/index.js';
import type { DateFieldAPI, FieldAPI } from '@philips-internal/oswald-ui-components';
import { ModalService, TimeFieldAPI } from '@philips-internal/oswald-ui-components';
import { ChemoStartAdmAliases, FragmentNames } from '../../codegen';
import type { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';

@Controller({ fragment: FragmentNames.CHEMO_START_ADM })
class ChemoStartAdmController extends BaseController {
  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
  submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(ChemoStartAdmAliases.DATE_START_ADM)
  declare dateStartAdm: DateFieldAPI;

  @Inject(ChemoStartAdmAliases.FIELD_START_ADM)
  declare fieldStartAdm: FieldAPI;

  @Inject(ChemoStartAdmAliases.TIME_FIELD_ADM)
  declare timeFieldAdm: TimeFieldAPI;

  @OnMount(ChemoStartAdmAliases.LAYOUT_0)
  onLayout0Mount(): void {
    const isStartAdm = this.context.getBulkData() as { isStart: boolean };
    if(!isStartAdm.isStart) {
      const label = MessageService.translate('text.device-end-date');
      this.fieldStartAdm.setLabel(label);
    }
  }

  @OnCancel(ChemoStartAdmAliases.FORM_START_ADM)
  onFormStartAdmCancel(): void {
    ModalService.close(FragmentNames.CHEMO_START_ADM);
  }

  @OnSubmit(ChemoStartAdmAliases.FORM_START_ADM)
  onFormStartAdmSubmit(event: SubmitEvent): void {
    const { record } = event;
    this.submittableFragmentContext.submit(new SubmitEvent({ record }));
  }
}

export default ChemoStartAdmController;
